import { create } from 'zustand';
import type { NavAction } from './nav.config';

/**
 * The sidebar's non-navigating entries.
 *
 * Two nav items run a handler instead of going somewhere — New Business and
 * Change API URL — and the button that triggers them sits at the bottom of a
 * recursive tree, several components below the shell that has to render the
 * dialog. A store is the short path between them; the alternative is threading
 * a callback through every level of `NavItem` rendering for the benefit of two
 * rows.
 *
 * Deliberately not persisted: reopening the app should not reopen a half-filled
 * "create a store" form.
 */
interface NavActionsStore {
  /** The action whose dialog is open, or null. */
  active: NavAction | null;
  open: (action: NavAction) => void;
  close: () => void;
}

export const useNavActions = create<NavActionsStore>((set) => ({
  active: null,
  open: (action) => set({ active: action }),
  close: () => set({ active: null }),
}));
